module.exports = __webpack_public_path__ + "static/media/notfound.d0e990fc.png";